import {
  RuleDefTypeEnum,
  TemplateNodeSchema,
} from '@ulysses-inc/harami_api_client'

/**
 * テンプレートノードがマスタ項目を参照しているかどうかを判定する
 * - answerOption（製品マスタから自動入力）が設定されている場合
 * - 数値ルールの設定方法が「製品マスタから設定する」の場合
 */
export const hasNodeMasterFieldReference = (
  node: TemplateNodeSchema,
): boolean => {
  if (node.question?.answerOption) {
    return true
  }
  const responseNumber = (node.question?.responseNumbers ?? [])[0]
  if (responseNumber?.ruleDefType === RuleDefTypeEnum.Master) {
    return true
  }
  return false
}
